import React from "react";
import { MODOS } from "../../lib/modoEngine";

const BRILLO_GRADIENT =
  "linear-gradient(to right, #1a1a2e 0%, #16213e 18%, #2d1b4e 36%, #533483 54%, #7a5eb8 72%, #B5A8F5 86%, #FFF8E1 100%)";

export interface ModoBrilloSpectrumProps {
  brillo: number;
  modoNombre: string;
  onSelectBrillo: (brillo: number) => void;
}

export const ModoBrilloSpectrum: React.FC<ModoBrilloSpectrumProps> = ({
  brillo,
  modoNombre,
  onSelectBrillo,
}) => {
  const min = MODOS[0]?.brillo ?? -5;
  const max = MODOS[MODOS.length - 1]?.brillo ?? 1;
  const span = max - min;

  return (
    <div className="flex flex-col items-end gap-2 shrink-0 w-[11rem]">
      <span className="text-[10px] font-sans uppercase tracking-widest text-white/30 w-full text-right">
        Brillo
      </span>
      <div className="relative w-full h-6 flex items-center">
        <div
          className="absolute left-0 right-0 top-1/2 -translate-y-1/2 h-px rounded-full"
          style={{ background: BRILLO_GRADIENT }}
        />
        {MODOS.map((m) => {
          const pct = span === 0 ? 0 : ((m.brillo - min) / span) * 100;
          const active = m.brillo === brillo;
          return (
            <button
              key={m.id}
              type="button"
              onClick={() => onSelectBrillo(m.brillo)}
              className={`absolute top-1/2 -translate-y-1/2 -translate-x-1/2 rounded-full transition-all ${
                active
                  ? "w-2 h-2 bg-emerald-400 shadow-[0_0_8px_#34d399]"
                  : "w-1 h-1 bg-white/35 hover:bg-white/55"
              }`}
              style={{ left: `${pct}%` }}
              title={m.nombre}
            />
          );
        })}
      </div>
      <div className="flex justify-between w-full text-[9px] font-mono text-white/25 tracking-wider">
        <span>Locrio</span>
        <span>Lidio</span>
      </div>
      <span className="text-[11px] font-serif text-white/70">{modoNombre}</span>
    </div>
  );
};
